import src from "IMAGE";
export default { src, width: 257, height: 116, blurWidth: 0, blurHeight: 0};
